import { orderBy } from "lodash";

export default class SupplierUsagePlan {
  constructor(data = {}) {
    this.setData(data);
  }

  setData(data = {}) {
    this.productCode = data.productCode || undefined;
    // this.productWarehouseGoodReceipts = orderBy(data?.productWarehouseGoodReceipts?.result || [], ["goodReceiptCode"], ["desc"]);
    this.productWarehouseGoodReceipts = orderBy(data?.productWarehouseGoodReceipts || [], ["goodReceiptCode"], ["desc"]);
    this.supplierProductUsagePlans = orderBy(data.supplierProductUsagePlans || [], ["goodReceiptCode", "planUseDate"], ["desc", "acs"]);
    // this.pageIndex = data?.productWarehouseGoodReceipts?.pageIndex || 1;
    // this.pageSize = data?.productWarehouseGoodReceipts?.pageSize || 10;
    // this.totalCount = data?.productWarehouseGoodReceipts?.totalCount || 0;
  }

  export() {
    return {
      productCode: this.productCode,
      productWarehouseGoodReceipts: this.productWarehouseGoodReceipts,
      supplierProductUsagePlans: this.supplierProductUsagePlans,
      // pageIndex: this.pageIndex,
      // pageSize: this.pageSize,
      // totalCount: this.totalCount
    };
  }
}

